import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { Experiment, JustATest, Original, StepByStepLoanSliderInput, Variant, withExperiment } from 'embed/experiments'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'
import { Auto, BasicLoan, Loan, SLR } from '../../loan-variant'

function questionCopy(loan: Loan) {
  switch (loan.kind) {
    case SLR().kind:
      return 'How much do you want to refinance?'
    case Auto().kind:
      return 'What is the remaining balance on your current auto loan?'
    case BasicLoan().kind:
      return 'How much do you need?'
    default:
      const exhaustiveCheck: never = loan
      return exhaustiveCheck
  }
}

function fieldVariant(loan: Loan) {
  switch (loan.kind) {
    case SLR().kind:
      return Fields.StudentLoanAmount
    case Auto().kind:
      return Fields.AutoRefinanceLoanAmount
    case BasicLoan().kind:
      return Fields.LoanAmount
    default:
      const exhaustiveCheck: never = loan
      return exhaustiveCheck
  }
}

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
  selectedVariantId?: string
  loanVariant: Loan
}

const TestComponent: React.FC = () => <div id="experiment" className="cohortExperiment" />
const TestComponentForCohortsExperiment = withExperiment(JustATest)(TestComponent)
function fieldSwitch(isSLR: boolean) {
  return isSLR ? Fields.StudentLoanAmount : Fields.LoanAmount
}
export const StepbystepApplicationStepLoanAmount: React.FC<Props> = (props) => (
  <Wrapper backToSearch={props.currentStep === 0} {...props}>
    <Experiment experiment={JustATest}>
      <Original>
        <div id="original" />
      </Original>
      <Variant experiment={JustATest} variant={JustATest.variants.JustATest}>
        <TestComponentForCohortsExperiment />
      </Variant>
    </Experiment>
    <StepTitle>{questionCopy(props.loanVariant)}</StepTitle>
    <ApplicationField
      onEnter={props.onEnter}
      product={Product.Loan}
      field={
        props.selectedVariantId === StepByStepLoanSliderInput.variants.SliderInput.id
          ? Fields.LoanAmountSlider
          : fieldVariant(props.loanVariant)
      }
    />
  </Wrapper>
)

export default withExperiment(StepByStepLoanSliderInput)(StepbystepApplicationStepLoanAmount)
